import { Controller } from "@hotwired/stimulus";
import 'swiper/css';
import { animate, onScroll } from "animejs";

export default class extends Controller {
    static targets = ["video"]

    initialize() {
        animate(this.element, {
            autoplay: onScroll({
                container: document.body,
                target: this.element,
                enter: 'center top',
                leave: 'center bottom',
                repeat: false,
                onEnter: this.onEnter.bind(this)
            }),
        });
    }

    getCurrentVideoIndex() {
        return 0;
    }

    onEnter() {
        this.triggerReplayEvent(this.getCurrentVideoIndex());
    }
    
    triggerReplayEvent(index) {
        const video = this.videoTargets[index];
        const event = new Event("replay");
        video.dispatchEvent(event);
    }
}